import { createSelector } from 'reselect';

const selectCustomFieldDefinitionsState = state => state.system.customFieldDefinitions;

export const selectCustomFields = createSelector(
  selectCustomFieldDefinitionsState,
  state => state.customFields || [],
);

export const selectCustomFieldsLoading = createSelector(
  selectCustomFieldDefinitionsState,
  state => !!state.isLoading,
);
